export const effarigQuotes = {
  initial: {
    id: 0,
    lines: [
      "Welcome to my humble abode.",
      "I am Effarig, and I govern Glyphs.",
      "I am different from Teresa; not as simplistic as you think.",
      "I use the shards of Glyphs to enforce my will.",
      "I collect them for the bounty of this realm.",
      "What are you waiting for? Get started.",
    ]
  },
  unlockWeights: {
    id: 1,
    lines: [
      "Do you like my little shop? It is not much, but it is mine."
    ]
  },
  unlockGlyphFilter: {
    id: 2,
    lines: [
      "This purchase will help you out."
    ]
  },
  unlockSetSaves: {
    id: 3,
    lines: [
      "Is that too much? I think it is too much."
    ]
  },
  unlockRun: {
    id: 4,
    lines: [
      "You bought out my entire stock... well, at least I am rich now.",
      "The heart of my Reality is suffering. Each Layer is harder than the last.",
      "I hope you never complete it.",
    ]
  },
  completeInfinity: {
    id: 5,
    lines: [
      { text: "You have completed Effarig's Infinity.", showCelestialName: false },
      "This is the first threshold. It only gets worse from here.",
      "None but me know enough about my domain to get further.",
    ]
  },
  completeEternity: {
    id: 6,
    lines: [
      { text: "You have completed Effarig's Eternity.", showCelestialName: false },
      "This is the limit. I do not want you to proceed past this point.",
      "You will not finish this in your lifetime.",
      "I will just wait here until you give up.",
    ]
  },
  completeReality: {
    id: 7,
    lines: [
      { text: "You have completed Effarig's Reality.", showCelestialName: false },
      "So this is the diabolical power... what frightened the others...",
      "Do you think this was worth it? Trampling on what I have done?",
      "And for what purpose? You could have joined, we could have cooperated.",
      "But no. It is over. Leave while I cling onto what is left.",
    ]
  },
  IntroOuter: {
    id: 8,
    lines: [
      "Welcome dear costumer",
      "I see in your eye that you already know me",
      "I don't really care, all I want is you to buy all my product",
      "And I'll be happy",
      "All I want is to be Happy"
    ]
  },
  OuterUnlock: {
    id: 9,
    lines: [
      "I...I don't know this realm of me",
      "Do not enter it, Please",
      
    ]
  }
};
